import { SessionableDataModel } from '../shared/sessionable-data-model';
import { SessionStorageService } from '../shared/session/session-storage/session-storage.service';
import { MortgageSessionDataModel } from './models/mortgage-session-data.model';

export abstract class SessionableMortgageDataModel extends SessionableDataModel {

  protected get key(): string {
    return SessionStorageService.MORTGAGE_SESSION_DATA_KEY;
  }

  // protected save<MortgageSessionDataModel, TMapTo>(setter: (model: TMapTo) => void): void {
  //   super.save<MortgageSessionDataModel, TMapTo>(setter);
  // }

  // protected abstract map<MortgageSessionDataModel, TMapTo>(model: MortgageSessionDataModel): TMapTo;

  // public getSessionData(): MortgageSessionDataModel {
  //   return super.getSessionData<MortgageSessionDataModel, any>();
  // }
}
